import type {
  CarerSkill,
  Need,
  ResidentNeed,
  Skill,
  SkillNeedTemplate
} from '@lmc/ts-common'
import { createSelector } from 'reselect'
import type { CarerSkillOption } from 'screens/Organisation/screens/SkillsScreen/CarerSkillsScreen'
import type { ProfileNeedOption } from 'screens/Residents/screens/ResidentNeedsScreen/ResidentNeedsScreen'
import {
  getNeeds,
  getSkillNeedTemplates,
  getSkills,
  getTemplateCategories
} from './Lists'

export const getNeedsAndSkillsTemplates = createSelector(
  [getSkills, getSkillNeedTemplates],
  (skillOptions?: Skill[], skillNeedTemplates?: SkillNeedTemplate[]) => {
    const temporaryTemplatesWithSkillName = skillNeedTemplates?.map(
      (template) => ({
        ...template,
        skillName:
          skillOptions?.find((skill) => skill.id === template.skill)?.name ||
          'N/A'
      })
    )

    return temporaryTemplatesWithSkillName?.sort((a, b) => {
      if (a.skillName?.toLowerCase() < b.skillName.toLowerCase()) return -1
      if (a.skillName?.toLowerCase() > b.skillName.toLowerCase()) return 1
      return 0
    })
  }
)

const getResidentId = (
  _state: unknown,
  props: { router: { params: { id: string } } }
) => {
  const {
    router: {
      params: { id }
    }
  } = props
  return id
}

const getCarerId = (
  _state: unknown,
  props: { router: { params: { id: string } } }
) => {
  const {
    router: {
      params: { id }
    }
  } = props
  return id
}

export const getResidentBaseFunction = (
  residentId: string,
  categories?: ProfileNeedOption[],
  needs?: ResidentNeed[]
) => {
  const needsFlattenOptions: Need[] = []

  categories?.forEach((item) =>
    item.needs?.forEach((need) => needsFlattenOptions.push(need as Need))
  )

  const temporaryResidentNeeds = needs
    ?.filter((need) => need.resident === residentId)
    ?.map((need) => ({
      ...need,
      needName:
        needsFlattenOptions?.find((needOption) => needOption.id === need.need)
          ?.name || 'N/A'
    }))

  return temporaryResidentNeeds?.sort((a, b) => {
    if (a.needName?.toLowerCase() < b.needName.toLowerCase()) return -1
    if (a.needName?.toLowerCase() > b.needName.toLowerCase()) return 1
    return 0
  })
}

export const getResidentNeeds = createSelector(
  [getResidentId, getTemplateCategories, getNeeds],
  (
    residentId: string,
    categories?: ProfileNeedOption[],
    needs?: ResidentNeed[]
  ) => {
    return getResidentBaseFunction(residentId, categories, needs)
  }
)

export const getCarerSkills = createSelector(
  [getCarerId, getTemplateCategories, getSkills],
  (carerId: string, categories?: CarerSkillOption[], skills?: CarerSkill[]) => {
    const skillFlattenOptions: any[] = []

    categories?.forEach((item) =>
      item.skills?.forEach((skill) => skillFlattenOptions.push(skill))
    )

    const temporaryCarerSkills = skills
      ?.filter((skill) => skill.carer === carerId)
      ?.map((skill) => ({
        ...skill,
        skillName:
          skillFlattenOptions?.find(
            (skillOption) => skillOption.id === skill.skill
          )?.name || 'N/A'
      }))

    return temporaryCarerSkills?.sort((a, b) => {
      if (a.skillName?.toLowerCase() < b.skillName.toLowerCase()) return -1
      if (a.skillName?.toLowerCase() > b.skillName.toLowerCase()) return 1
      return 0
    })
  }
)
